module.exports = __webpack_public_path__ + "img/bidding-icon.b1beaa22.png";